'use client';

import { Box, Checkbox, factory, Flex, Grid, omitText, Typography } from '@kohler-dsm-library/kohler-core';
import { ArrowLeftIcon, CloseIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { isValidElement } from 'react';
import classes from './index.module.scss';
import { ZipCodeInputField } from './ZipCodeInputField';
import ZipCodeInfoModal from '@/components/core/Modal/ZipCodeInfoModal';

export const StoreMenu = factory((props, ref) => {
  const {
    className,
    heading,
    CTAs,
    eyebrow,
    subheading,
    storeInfo,
    zipCodeInput,
    setStoreCTA,
    setMenuType,
    setIsOpenMobileMenu,
    infoModal,
    infoModalErrror,
    setInfoModal,
    staticTexts,
    ...rest
  } = props;
  const classNames = clsx(className, 'kohler-store-menu-root', classes.storeMenu);

  // Desktop backdrop click handler
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setMenuType?.(null);
      if (setIsOpenMobileMenu) setIsOpenMobileMenu(false);
    }
  };

  return (
    <>
      {infoModal && (
        <ZipCodeInfoModal
          handleModalClose={() => setInfoModal(false)}
          show={infoModal}
          data={infoModalErrror}
          labelledBy="Geo-Location-error-message"
          className="message-modal"
          staticTexts={staticTexts}
          dataLayerPosition="global header"
        />
      )}
    <div className={classes.storeMenuBackdrop} onClick={handleBackdropClick}>
    <Box id="store-menu" component="div" ref={ref} className={classNames} {...rest}>
      <Grid className={clsx('center-grid', classes.storeMenuMainGrid)}>
        <Flex className={classes.storeMenuMobileClose}>
          <Box
            component="button"
            type="button"
            onClick={() => {
              setMenuType?.(null);
              if (setIsOpenMobileMenu) {
                setIsOpenMobileMenu(false);
              }
            }}
            className={classes.storeMenuMobileCloseIcon}
          >
            <CloseIcon withBoundingBox={false} size="medium" />
          </Box>
          <Typography
            size="label-regular-m"
            component="button"
            type="button"
            textColor="var(--content-secondary)"
            className={classes.storeMenuMobileBackText}
            onClick={() => setMenuType?.(null)}
          >
            <ArrowLeftIcon withBoundingBox={false} size="small" /> Menu
          </Typography>
        </Flex>
        <Flex className={clsx(classes.storeMenuMainContent, !storeInfo && classes.storeMenuMainFullContent)}>
          <Flex className={classes.storeMenuContentHeading}>
            {eyebrow && (
              <Typography
                size="label-medium-m"
                textColor="var(--content-primary)"
                component={isValidElement(eyebrow.text) ? 'div' : eyebrow.component || 'p'}
                className={classes.storeMenuEyebrow}
              >
                {eyebrow.text}
              </Typography>
            )}
            <Typography
              size="navigation-overlay-title"
              textColor="var(--content-primary)"
              className={classes.storeMenuHeadingCustom}
            >
              {heading.text}
            </Typography>
            {subheading && (
              <Typography
                size="label-regular-m"
                textColor="var(--content-primary)"
                component={isValidElement(subheading.text) ? 'div' : subheading.component || 'p'}
                className={classes.storeMenuSubheadingCustom}
              >
                {subheading.text}
              </Typography>
            )}
          </Flex>
          {/* Only show store info block when "My Store" is selected */}
          {storeInfo && setStoreCTA?.checked && (
            <Flex className={classes.storeMenuContentInfoContainer}>
              <Typography className={classes.storeMenuContentInfo} size="label-regular-m" component="div">
                {storeInfo}
              </Typography>
              {setStoreCTA && <Checkbox {...setStoreCTA} />}
            </Flex>
          )}
        </Flex>
        <Flex className={classes.storeMenuZipContainer}>
          {zipCodeInput.eyebrow && (
            <Typography
              size="label-medium-m"
              className={classes.storeMenuContentZipContainerEyebrow}
              component={isValidElement(zipCodeInput.eyebrow.text) ? 'div' : zipCodeInput.eyebrow.component || 'p'}
            >
              {zipCodeInput.eyebrow.text}
            </Typography>
          )}
          <ZipCodeInputField {...zipCodeInput} />
          {CTAs && (
            <ul className={classes.storeMenuContentList}>
              {CTAs.map((CTA) => {
                return (
                  <li key={CTA.text}>
                    <Typography
                      component={CTA.component || 'a'}
                      {...omitText(CTA)}
                      className={clsx(classes.storeMenuContentListItemLink)}
                      size="label-regular-m"
                    >
                      {CTA.text}
                    </Typography>
                  </li>
                );
              })}
            </ul>
          )}
        </Flex>
      </Grid>
    </Box>
    </div>
    </>
  );
});